/* eslint-disable sonarjs/no-duplicate-string */

export const eucdmCodes = {
  'messageInfo.declarationMainType': '11 01 000 000',
  'messageInfo.declarationType': '11 02 000 000',
  'messageInfo.security': '11 07 000 000',
  'consignment.customsSupervisingOffice.referenceNumber': {
    NL: '17 02 001 000',
    BE: '17 10 001 000',
  },

  'declaration.consignment.locationOfGoods.unLocode': '16 15 036 000',
  'consignment.customsOfficePresentation.referenceNumber': '17 09 001 000',

  // procudure

  'goodShipmentGlobal.customsProcedure.current': '11 09 001 000',
  'goodShipmentGlobal.customsProcedure.previous': '11 09 002 000',
  'goodShipmentGlobal.preference': '14 11 000 000',

  // transport

  'consignment.countryOfDispatch': '16 06 000 000',
  'consignment.countryOfDestination': '16 03 000 000',
  'consignment.regionOfDestination': { NL: null, BE: '16 04 000 000' },
  'transportInformation.activeBorderTransportMeans.nationality': '19 08 062 000',
  'transportInformation.modeOfTransportMeansAtTheBorder': '19 03 000 000',
  'transportInformation.arrivalTransportMeans.identificationNumber': '19 06 017 000',
  'transportInformation.arrivalTransportMeans.typeOfIdentification': '19 06 061 000',
  'transportInformation.inlandModeOfTransport': '19 04 000 000',
  'transportInformation.transportEquipment.containers': '19 07 063 000',

  // customs treatment

  'messageInfo.methodOfPayment': '14 03 038 000',
  'valuationInformationTaxes.valuationMethod': '14 10 000 000',
  'valuationInformationTaxes.valuationAdjustment.valuationIndicators': '14 07 000 000',
  'declarationGlobal.totalAmountInvoiced': '14 06 000 000',
  'goodShipmentGlobal.invoiceCurrency': '14 05 000 000',
  'valuationInformationTaxes.deliveryTerms.incotermCode': '14 01 035 000',

  // Previous Documents

  'documents.previousDocuments.type': '12 01 002 000',
  'documents.previousDocuments.referenceNumber': '12 01 001 000',
  'documents.previousDocuments.typeOfPackages': {
    NL: null,
    BE: '12 01 003 000',
  },
  'documents.previousDocuments.numberOfPackages': {
    NL: null,
    BE: '12 01 004 000',
  },
  'documents.previousDocuments.measurementUnitAndQualifier': {
    NL: null,
    BE: '12 01 005 000',
  },
  'documents.previousDocuments.quantity': {
    NL: null,
    BE: '12 01 006 000',
  },
  'documents.previousDocuments.goodsItemIdentifier': '12 01 007 000',

  // Supporting Documents

  'documents.supportingDocuments.type': '12 03 002 000',
  'documents.supportingDocuments.referenceNumber': '12 03 001 000',
  'documents.supportingDocuments.dateOfValidity': '12 03 011 000',
  'documents.supportingDocuments.documentLineItemNumber': '12 03 013 000',
  'documents.supportingDocuments.issuingAuthorityName': '12 03 010 000',
  'documents.supportingDocuments.measurementUnitAndQualifier': '12 03 005 000',
  'documents.supportingDocuments.quantity': '12 03 006 000',
  'documents.supportingDocuments.currency': '12 03 012 000',
  'documents.supportingDocuments.amount': '12 03 014 000',

  // Transport Documents

  'documents.transportDocuments.type': '12 05 002 000',
  'documents.transportDocuments.referenceNumber': '12 05 001 000',

  // Additional Reference

  'documents.additionalReference.type': '12 04 002 000',
  'documents.additionalReference.referenceNumber': '12 04 001 000',

  // Additional Information

  'documents.additionalInformation.code': '12 02 008 000',
  'documents.additionalInformation.text': '12 02 009 000',

  // Guarantee Documents

  'documents.guaranteeDocuments.type': '99 02 000 000',
  'documents.guaranteeDocuments.reference.grn': '99 03 069 000',
  'documents.guaranteeDocuments.reference.accessCode': '99 03 070 000',
  'documents.guaranteeDocuments.reference.currencyCode': '99 03 012 000',
  'documents.guaranteeDocuments.reference.amountTobeCovered': '99 03 071 000',
  'documents.guaranteeDocuments.reference.otherGuaranteeReference': '99 03 073 000',
  'documents.guaranteeDocuments.reference.customsOfficeGuarantee.referenceNumber': '99 03 072 000',

  // Warehouse Documents

  'documents.warehouseDocuments.type': '12 11 002 000',
  'documents.warehouseDocuments.identifier': '12 11 015 000',

  // Authorisation Documents

  'documents.authorisationDocuments.type': '12 12 002 000',
  'documents.authorisationDocuments.referenceNumber': '12 12 001 000',
  'documents.authorisationDocuments.holderOfTheAuthorisation': '12 12 080 000',

  // Additions and Deductions Documents

  'documents.additionsAndDeductionsDocuments.code': '14 04 008 000',
  'documents.additionsAndDeductionsDocuments.amount': '14 04 014 000',

  // Additional Fiscal Reference Documents

  'documents.additionalFiscalReference.role': '13 16 031 000',
  'documents.additionalFiscalReference.vatIdentificationNumber': '13 16 034 000',

  'firstItemData.taricAdditionalCode': '18 09 059 000',
  'firstItemData.nationalAdditionalCode': '18 09 060 000',

  // Goods Shipment
  'goodShipmentGlobal.firstItemData.invoiceDescription': '18 05 000 000',
  'goodShipmentGlobal.firstItemData.typeOfGoods': '18 10 001 000',
  'goodShipmentGlobal.firstItemData.cusCode': '18 08 001 000',
  'otherDataElements.quotaOrderNumber': '99 01 000 000',

  'goodShipmentGlobal.firstItemData.hsCode': '18 09 056 000',
  'goodShipmentGlobal.firstItemData.taricAdditionalCode': '18 09 059 000',
  'goodShipmentGlobal.firstItemData.nationalAdditionalCode': '18 09 060 000',

  'goodsShipmentItems.referenceNumberUCR': '12 08 000 000',
  'goodsShipmentItems.additionalProcedure': '11 10 000 000',
  'goodsShipmentItems.descriptionOfGoods': '18 05 000 000',
  'goodsShipmentItems.commodityCode.hsCode': '18 09 056 000',
  'goodsShipmentItems.goodsMeasure.intrinsicValue': '14 14 014 000',
  'goodsShipmentItems.goodsMeasure.currencyCode': '14 14 012 000',
  'goodsShipmentItems.goodsMeasure.grossMass': '18 04 000 000',
  'goodsShipmentItems.goodsMeasure.supplementaryUnits': '18 02 000 001',
  'goodsShipmentItems.transportInsurance.currencyCode': '14 15 012 000',
  'goodsShipmentItems.transportInsurance.amount': '14 15 014 000',
  'goodsShipmentItems.packaging.typeOfPackages': '18 06 003 000',
  'goodsShipmentItems.packaging.numberOfPackages': '18 06 004 000',
  'goodsShipmentItems.packaging.shippingMarks': '18 06 054 000',
  'goodsShipmentItems.dutiesAndTaxes.items.taxBase.taxRate': '14 03 040 041',
  'goodsShipmentItems.dutiesAndTaxes.items.taxBase.quantity': '14 03 040 006',
  'goodShipmentGlobal.itemAmountInvoiced': '14 08 000 000',
  'goodShipmentGlobal.exchangeRate': '14 09 000 000',
  'goodShipmentGlobal.totalNetMass': '18 04 001 000',
  'goodShipmentGlobal.totalQuantitySupplementaryUnits': '18 02 000 000',
  'consignment.countryOfOrigin': '16 08 000 000',
  'consignment.regionOfOrigin': '16 10 001 000',
  'consignment.countryOfPreferentialOrigin': '16 09 000 000',

  // STAKEHOLDERS
  // Exporter
  'stakeholders.exporter.name': '13 01 016 000',
  'stakeholders.exporter.identificationNumber': '13 01 017 000',
  'stakeholders.exporter.address.street': '13 01 018 019',
  'stakeholders.exporter.address.postcode': '13 01 018 021',
  'stakeholders.exporter.address.city': '13 01 018 022',
  'stakeholders.exporter.address.country': '13 01 018 020',

  // Importer
  'stakeholders.importer.name': '13 04 016 000',
  'stakeholders.importer.identificationNumber': '13 04 017 000',
  'stakeholders.importer.address.street': '13 04 018 019',
  'stakeholders.importer.address.postcode': '13 04 018 021',
  'stakeholders.importer.address.city': '13 04 018 022',
  'stakeholders.importer.address.country': '13 04 018 020',

  // Declarant
  'stakeholders.declarant.name': '13 05 016 000',
  'stakeholders.declarant.identificationNumber': '13 05 017 000',
  'stakeholders.declarant.address.street': '13 05 018 019',
  'stakeholders.declarant.address.postcode': '13 05 018 021',
  'stakeholders.declarant.address.city': '13 05 018 022',
  'stakeholders.declarant.address.country': '13 05 018 020',
  'stakeholders.declarant.contactPerson.name': '13 05 074 016',
  'stakeholders.declarant.contactPerson.phoneNumber': '13 05 074 075',
  'stakeholders.declarant.contactPerson.email': '13 05 074 076',

  // Representative
  'stakeholders.representative.identificationNumber': '13 06 017 000',
  'stakeholders.representative.status': '13 06 030 000',
  'stakeholders.representative.address.street': '13 06 018 023',
  'stakeholders.representative.address.postcode': '13 06 018 021',
  'stakeholders.representative.address.city': '13 06 018 022',
  'stakeholders.representative.address.country': '13 06 018 020',

  'stakeholders.additionalSupplyChainActor.identificationNumber': '13 14 017 000',
  'stakeholders.additionalSupplyChainActor.role': '13 14 031 000',

  // Customs Treatment EUCDM codes
  'messageInfo.deferredPayment': '12 12 001 000',
  'messageInfo.deferredPaymentVAT': '12 12 001 000',
  'documents.additionalFiscalReference.accountHolder': '12 12 080 000',
  'valuationInformationTaxes.globalChargesimport.CustomsCharges.charges': '14 04 014 000',
  'valuationInformationTaxes.globalChargesimport.VATcharges.charges': '14 04 014 000',
  'consignment.transportCost.currencyCode': '14 05 000 000',
  'consignment.transportCost.amount': '14 06 000 000',

  'consignment.referenceNumberUCR': '12 08 000 000',
  'otherDataElements.registrationNumber': '17 04 000 000',
  'messageInfo.acceptanceDate': '15 09 001',
  'otherDataElements.natureOfTransaction': '99 05 000 000',
  'valuationInformationTaxes.deliveryTerms.location': '14 01 037 000',
  'valuationInformationTaxes.deliveryTerms.country': '14 01 020 000',

  // Buyer
  'buyer.name': '13 09 016 000',
  'buyer.identificationNumber': '13 09 017 000',
  'buyer.address.street': '13 09 019 019',
  'buyer.address.postcode': '13 09 019 021',
  'buyer.address.city': '13 09 019 022',
  'buyer.address.country': '13 09 019 020',

  // Seller
  'seller.name': '13 08 016 000',
  'seller.identificationNumber': '13 08 017 000',
  'seller.address.street': '13 08 018 019',
  'seller.address.postcode': '13 08 018 021',
  'seller.address.city': '13 08 018 022',
  'seller.address.country': '13 08 018 020',
};
